export default {
    setStateValue(state, payload)
    {
        if (state.hasOwnProperty(payload.key)) {
            state[payload.key] = payload.value;
        }
    },
}
